import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MenusCacheService } from './cached/menus-cache.service';
import { PlatsCacheService } from './cached/plats-cache.service';
import { FeatureCacheService } from './feature-cache.service';
import { Categorie, Collaborateur, Creneau, Succursale, UserSuccursale } from './models';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  prefixUrl: string = environment.apiUrl+'/api';
  

  constructor(private http: HttpClient, 
              private featureCacheService: FeatureCacheService, 
              private menusCacheService: MenusCacheService,
              private platsCacheService: PlatsCacheService) {
    
  }

  public handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }


  public getAllCreneaux$(): Observable<Creneau[]>{
    return this.http.get<Creneau[]>(`${this.prefixUrl}/creneau/getCreneaux`);
  }

  public getAllCreneauxBySuccursaleId$(id: any): Observable<Creneau[]>{
    return this.http.get<Creneau[]>(`${this.prefixUrl}/creneau/getCreneaux/${id}`);
  }

  public saveCreneau$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/creneau/addCreneau`, data);
  }

  public updateCreneau$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/creneau/updateCreneau`, data);
  }

  public deleteCreneau$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/creneau/deleteCreneau/${id}`);
  }

  public getAllSuccursales$(): Observable<Succursale[]>{
    return this.http.get<Succursale[]>(`${this.prefixUrl}/succursale/getSuccursales`);
  }

  public saveSuccursale$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/succursale/addSuccursale`, data);
  }

  public updateSuccursale$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/succursale/updateSuccursale`, data);
  }

  public deleteSuccursale$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/succursale/deleteSuccursale/${id}`);
  }

  public getAlluserSuccursales$(): Observable<UserSuccursale[]>{
    return this.http.get<UserSuccursale[]>(`${this.prefixUrl}/userSuccursale/getUserSuccursales`);
  }
  public saveUserSuccursale$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/userSuccursale/addUserSuccursale`, data);
  }

  public updateUserSuccursale$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/userSuccursale/updateUserSuccursale`, data);
  }

  public getUserSuccursaleByUserId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/userSuccursale/getSuccursaleByUserId/${id}`);
  }

  public getUsersBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/userSuccursale/getUsersBySuccursaleId/${id}`);
  }


  public deleteSemaine$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/semaine/deleteSemaine/${id}`);
  }
  public addCreneauToCategorie$(idCreneau: any, idCategorie: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/creneau/add/creneau/${idCreneau}/categorie/${idCategorie}`, {});
  }

  public getAllCategories$(): Observable<Categorie[]>{
    return this.http.get<Categorie[]>(`${this.prefixUrl}/categorie/getCategories`);
  }

  public getAllCategoriesBySuccursaleId$(id: any): Observable<Creneau[]>{
    return this.http.get<Creneau[]>(`${this.prefixUrl}/categorie/getCategories/${id}`);
  }


  public getCategorie$(categorieId: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/categorie/getCategorie/${categorieId}`);
  }

  public saveCategorie$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/categorie/addCategorie`, data);
  }  

  public updateCategorie$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/categorie/updateCategorie`, data);
  }

  public deleteCategorie$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/categorie/deleteCategorie/${id}`);
  }

  public detachCreneaufromCategorie$(categorieId: any, creneauId: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/categorie/delete/categorie/${categorieId}/creneau/${creneauId}`);
  }

  public getAllCollaborateurs$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/getCollaborateurs`);
  }

  

  public getCollaborateursByCategorieId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/categorie/`+id);
  }

  public getCollaborateurById$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/getCollaborateur/${id}`);
  }

  public saveCollaborateur$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/collaborateur/addCollaborateur`, data).pipe(
      map((response: any) => {
        //this.featureCacheService.clearCache();
        return response;
      }),
      );
  }  

  public updateCollaborateur$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/collaborateur/updateCollaborateur`, data).pipe(
      map((response: any) => {
        //this.featureCacheService.clearCache();
        return response;
      }),
      );;
  }

  public deleteCollaborateur$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/collaborateur/deleteCollaborateur/${id}`);
  }

  public uploadFileCollaborateur$(collaborateurId: any, data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/collaborateur/uploadFile/${collaborateurId}`, data, {
      /* headers: new HttpHeaders({
        'Content-Type':  'multipart/form-data',
      }) */
      
    });
  } 

  public getStatsByJour$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/commande/stats/jour`);
  }

  
  public getAllExternes$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/externe/getExternes`);
  }
  public getExterneById$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/externe/getExterne/${id}`);
  }

  public saveExterne$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/externe/addExterne`, data);
  }  

  public updateExterne$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/externe/updateExterne`, data);
  }

  public deleteExterne$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/externe/deleteExterne/${id}`);
  }


  //MENU DE LA SEMAINE
  public getAllSemaines$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/semaine/getSemaines`);
  }

  public getSemaineById$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/semaine/getSemaine/${id}`);
  }

  public getAllSemainesBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/semaine/getSemaines/${id}`);
  }

  public getAllSemainesPageBySuccursaleId$(id: any, pageParam : {pageNo : number, pageSize: number}): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/semaine/getPageSemaines/${id}?pageNo=${pageParam.pageNo}&pageSize=${pageParam.pageSize}`);
  }

  public saveSemaine$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/semaine/addSemaine`, data);
  }

  public saveJSTMAll$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/jstm/addAllJstm`, data);
  }

  public async getLastSemaine(){
    let item = null;
    await this.getAllSemaines$().subscribe(
      (data: any) => {
        if(data.length != 0){
          item = data[data.length - 1];
        }
    });
    
    return item;
  }

  public getAllJSTMBySemaineId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/jstm/semaine/${id}`);
  }

  public saveJSTM$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/jstm/addJstm`, data);
  }

  public updateJSTM$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/jstm/updateJstm`, data);
  }

  public updateMenu$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/menu/updateMenu`, data);
  }

  public addMenu$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/menu/addMenu`, data);
  }
  
  public addMenuWithPlats$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/menu/addMenuWithPlats`, data);
  }

  public getMenuByNomAndSuccursaleId$(nom: string, succursale_id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenuByNom/${nom}/${succursale_id}`);
  }

  public deletePlatsByMenuId$(data: any, id:any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/menu/deletePlats/${id}`, data);
  }

  public getAllMenu$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenus`);
  }

  public getAllJour$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/jour/getJours`);
  }

  public getAllTypeMenu$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/typeMenu/getTypeMenus`);
  }

  public getAllTypeMenuBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/typeMenu/getTypeMenus/${id}`);
  }

  public saveTypeMenu$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/typeMenu/addTypeMenu`, data);
  }

  public updateTypeMenu$(data: any): Observable<any>{
    return this.http.put<any>(`${this.prefixUrl}/typeMenu/updateTypeMenu`, data);
  }

  public deleteTypeMenu$(id: any): Observable<any>{
    return this.http.delete<any>(`${this.prefixUrl}/typeMenu/deleteTypeMenu/${id}`);
  }


  public savePlat$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/plat/addPlat`,data).pipe(
      map((response: any) => {
        //this.platsCacheService.clearCache();
        return response;
      }),
      );
    //return this.http.post<any>(`${this.prefixUrl}/plat/addPlat`, data);
  }
  public getAllPlat$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/plat/getPlat`);
  }
  public getAllPlatBySuccursaleId$(id: any): Observable<any>{
    /* let all$ = this.platsCacheService.getValue(id);
    if (!all$) {
      all$ = this.http.get(`${this.prefixUrl}/plat/getPlats/${id}`).pipe(
        map((response: any) => response),
        shareReplay(1)
      );
      this.platsCacheService.setValue(all$, id);
    }
    return all$; */
    return this.http.get<any>(`${this.prefixUrl}/plat/getPlats/${id}`);
  }

  public postStatsByTwoDates$(data: any): Observable<any>{
    console.log(data);
    return this.http.post<any>(`${this.prefixUrl}/commande/stats/twoDates`, data);
  }

  public postStatsOfToDay$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/stats/jour_with_type_menu/filter`, data);
  }

  public postStatsOfToDayBySuccursaleId$(data: any, id: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/stats/jour_with_type_menu/filter/${id}`, data);
  }
  
  
  public postStatsByTwoDatesV2$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/stats/twoDates_with_type_menu`, data);
  }

  public postStatsByTwoDatesV2BySuccursaleId$(data: any, id: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/stats/twoDates_with_type_menu/${id}`, data);
  }

  public saveMenu$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/menu/addMenu`, data);
  }

  public getMenuById$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenu/${id}`);
  }

  public associatePlatAndMenu$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/platMenu/addPlatMenu`, data);
  }

  //Pour enrégistrer commande
  public getMenuDuJour$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenuDuJour`);
  }

  public getMenuDuJourBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenuDuJour/${id}`);
  }

  public getCurentTypeMenuId$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getCurrentTypeMenuId`);
  }

  public getCurentTypeMenuIdBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getCurrentTypeMenuId/${id}`);
  }

  

  public getCurentSemaine$(): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getCurrentSemaine`);
  }

  public getCurentSemaineBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/menu/getCurrentSemaine/${id}`);
  }

  public getCollaborateurExistForMenu$(matricule: string): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/getCollaborateurExistsForMenu/${matricule}`);
  }

  public saveCommande$(data: any): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/addCommandeWithPlats`, data);
  }

  public saveCommandeVerifyMatricule$(data: any, matricule: string): Observable<any>{
    return this.http.post<any>(`${this.prefixUrl}/commande/addCommandeWithPlatsVerifiyMatricule/${matricule}`, data);
  }

  public getAllMenuBySuccursaleId$(id: any): Observable<any>{
    /* let all$ = this.menusCacheService.getValue(id);
    if (!all$) {
      all$ = this.http.get(`${this.prefixUrl}/menu/getMenus/${id}`).pipe(
        map((response: any) => response),
        shareReplay(1)
      );
      this.menusCacheService.setValue(all$, id);
    }
    return all$; */
    return this.http.get<any>(`${this.prefixUrl}/menu/getMenus/${id}`);
  }

  

  public getAllCommandeBySuccursaleId$(id: any): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/commande/getCommandes/${id}`);
  }

  public getAllCollaborateursBySuccursaleId$(id: any): Observable<any>{
    /* let all$ = this.featureCacheService.getValue(id);
    if (!all$) {
      all$ = this.http.get(`${this.prefixUrl}/collaborateur/getCollaborateurs/${id}`).pipe(
        map((response: any) => response),
        shareReplay(1)
      );
      this.featureCacheService.setValue(all$, id);
    }
    return all$; */
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/getCollaborateurs/${id}`);
  }

  public getAllCollaborateursPageBySuccursaleId$(id: any, pageParam : {pageNo : number, pageSize: number}): Observable<any>{
    return this.http.get<any>(`${this.prefixUrl}/collaborateur/getPageCollaborateurs/${id}?pageNo=${pageParam.pageNo}&pageSize=${pageParam.pageSize}`);
  }

}
